namespace advisorop.components.servicer {

    class SelectCuAdvisoryFirmServicerController {
        $router;
        selectedAdvisoryFirm: domains.IAdvisoryFirm;
        isAdvisoryFirmSelected: boolean = false;
        onSelectedAdvisoryFirm: any;
        accounts: any;
        clearAfterSelect: string = "true";

        static $inject = ["servicerService", "advisoryFirmApi"];
        constructor(
            private servicerService: services.ServicerService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {
        }
         

        searchAdvisoryFirm(searchTerm: string): ng.IPromise<{}> {

            return this.advisoryFirmApi.searchByName(searchTerm, this.companyGroupId)
                .then((response) => {
                    return <Array<domains.IAdvisoryFirm>>response.data;
                });
        }

        onSelectAdvisoryFirm(item, model, label, event): void {            
            this.isAdvisoryFirmSelected = true;
            this.onSelectedAdvisoryFirm({ advisoryFirm: item });
            if (this.clearAfterSelect === "true")
                this.resetSearch();
          //  this.selectedAdvisoryFirm = item;
            //this.loadUnmappedAccounts();
        }

        resetSearch(): void {
            this.selectedAdvisoryFirm = null;
            //this.advisor = null;
            //this.isAdvisorFormVisible = false;
            //this.noResults = true;
        };

        clearSelectedAdvisoryFirm(): void {
            this.selectedAdvisoryFirm = null;
            this.isAdvisoryFirmSelected = false;
            this.onSelectedAdvisoryFirm({ advisoryFirm: null });
        }

        loadUnmappedAccounts(): void {

            // WILL NEED TO FIX THIS - USE EXTERNAL MAPPING TABLE TO MAP FIRM TO BO SYSTEM...
            //var rez = this.servicerService.getUnmappedAccounts(this.selectedAdvisoryFirm.ppFirmId);
            var rez = this.servicerService.getUnmappedAccounts("0");

            rez.then((data) => {
                this.accounts = data.data;
            }).catch((data) => {
                toastr.error("Error " + data.status + " " + data.data);
            });
        };

        loadAdvisoryFirmById(advisoryFirmId: number): void {
            this.servicerService.getCompanyGroup(advisoryFirmId)
                .then(data => {
                    this.selectedAdvisoryFirm = data.data;
                    this.onSelectedAdvisoryFirm({ advisoryFirm: this.selectedAdvisoryFirm });

                })
                .catch(err => { toastr.error("Unable to fetch advisory firm!"); })
        }

        advisoryFirmId: number;
        companyGroupId: number;

        $onInit(): void {
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "companyGroupId") {
                    if (this.companyGroupId > 0) {
                        this.companyGroupId = this.companyGroupId;
                    }
                }
               
            }
        }


        $routerOnActivate(next, previous) {
        }


    }


    class SelectCuAdvisoryFirmServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": '<',
                onSelectedAdvisoryFirm: '&',
                advisoryFirmId: "<",
                companyGroupId: "<",
                clearAfterSelect: "@",
            };
            this.controller = SelectCuAdvisoryFirmServicerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/select-cu-advisory-firm-servicer.html';
        }
    }
    angular.module(Constants.APP).component("selectCuAdvisoryFirmServicer", new SelectCuAdvisoryFirmServicer());


}